module.exports = __webpack_public_path__ + "static/media/mshtml_32542.97c23337.ico";